export enum ThemeType {
  Light = 'light',
  Dark = 'dark',
}

export function getThemeCssClass(theme: ThemeType) {
  switch (theme) {
    case ThemeType.Dark:
      return 'dark';

    default:
      return '';
  }
}
